import { HelpCircle } from "lucide-react";
import { useCore } from "../lib/core";
import { useHelp } from "./HelpHost";

/**
 * The `?` in the top bar. Deliberately always available: unlike the assistant
 * FAB it is not gated on a module or a permission, because the guide filters
 * itself article by article and a reader with no modules still needs to know
 * how to sign in and find their way around.
 */
export function HelpButton() {
  const core = useCore();
  const { open } = useHelp();
  const label = core.i18n.t("help.contextual");

  return (
    <button
      type="button"
      onClick={open}
      aria-label={label}
      title={label}
      // Same shape and weight as its neighbours (ThemeToggle, NotificationBell):
      // quiet 36px glyph — muted at rest, ink on hover — so the three topbar
      // controls read as one family.
      className="flex h-9 w-9 min-h-touch min-w-touch items-center justify-center rounded-md text-fg-muted transition-colors duration-fast hover:bg-hover hover:text-fg-default sm:min-h-0 sm:min-w-0"
    >
      <HelpCircle size={18} aria-hidden />
    </button>
  );
}
